function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createRoot } from 'react-dom/client';
import SignInModal from "./ui";
import { PortkeyProvider } from '@portkey/did-ui-react';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function mountApp(bridgeInstance, wallets, baseConfig) {
  if (typeof window === 'undefined') {
    return;
  }
  console.log('mountApp--');
  var containerElementQuery = 'body';
  var containerElement = document.querySelector(containerElementQuery);
  if (!containerElement) {
    throw new Error("Element with query ".concat(containerElementQuery, " does not exist."));
  }
  var SignInWrapperDom = document.createElement('div');
  SignInWrapperDom.setAttribute('id', 'sign-in-wrapper');
  var root = createRoot(SignInWrapperDom);
  root.render( /*#__PURE__*/_jsx(PortkeyProvider, _objectSpread(_objectSpread({}, baseConfig.PortkeyProviderProps), {}, {
    networkType: baseConfig.networkType,
    children: /*#__PURE__*/_jsx(SignInModal, {
      bridgeInstance: bridgeInstance,
      wallets: wallets,
      baseConfig: baseConfig
    })
  })));
  containerElement.appendChild(SignInWrapperDom);
}
export function useMountSignIn(bridgeInstance, wallets, baseConfig, children) {
  var SignInNode = useMemo(function () {
    return /*#__PURE__*/_jsxs(PortkeyProvider, _objectSpread(_objectSpread({}, baseConfig.PortkeyProviderProps), {}, {
      networkType: baseConfig.networkType,
      children: [/*#__PURE__*/_jsx(SignInModal, {
        bridgeInstance: bridgeInstance,
        wallets: wallets,
        baseConfig: baseConfig
      }), children]
    }));
  }, [baseConfig, bridgeInstance, children, wallets]);
  return SignInNode;
}
export function unMountApp() {
  if (typeof window === 'undefined') {
    return;
  }
  var SignInWrapperDom = document.querySelector('#sign-in-wrapper');
  if (!SignInWrapperDom) {
    return;
  }
  document.body.removeChild(SignInWrapperDom);
}